import polygonsIconLg from '@disy/cadenza-icons/area-lg.svg';
import polygonsIcon from '@disy/cadenza-icons/area.svg';
import chartBarBulletIconLg from '@disy/cadenza-icons/chart-bar-bullet-lg.svg';
import chartBarBulletIcon from '@disy/cadenza-icons/chart-bar-bullet.svg';
import chartBarIconLg from '@disy/cadenza-icons/chart-bar-lg.svg';
import chartBarIcon from '@disy/cadenza-icons/chart-bar.svg';
import chartColumnBulletIconLg from '@disy/cadenza-icons/chart-column-bullet-lg.svg';
import chartColumnBulletIcon from '@disy/cadenza-icons/chart-column-bullet.svg';
import chartColumnIconLg from '@disy/cadenza-icons/chart-column-lg.svg';
import chartColumnIcon from '@disy/cadenza-icons/chart-column.svg';
import chartGroupedBarIconLg from '@disy/cadenza-icons/chart-grouped-bar-lg.svg';
import chartGroupedBarIcon from '@disy/cadenza-icons/chart-grouped-bar.svg';
import chartGroupedColumnIconLg from '@disy/cadenza-icons/chart-grouped-column-lg.svg';
import chartGroupedColumnIcon from '@disy/cadenza-icons/chart-grouped-column.svg';
import chartLineIconLg from '@disy/cadenza-icons/chart-line-lg.svg';
import chartLineIcon from '@disy/cadenza-icons/chart-line.svg';
import chartMirrorBarIconLg from '@disy/cadenza-icons/chart-mirror-bar-lg.svg';
import chartMirrorBarIcon from '@disy/cadenza-icons/chart-mirror-bar.svg';
import chartMultiLineIconLg from '@disy/cadenza-icons/chart-multi-line-lg.svg';
import chartMultiLineIcon from '@disy/cadenza-icons/chart-multi-line.svg';
import chartPieIconLg from '@disy/cadenza-icons/chart-pie-lg.svg';
import chartPieIcon from '@disy/cadenza-icons/chart-pie.svg';
import chartScatterPlotIconLg from '@disy/cadenza-icons/chart-scatter-lg.svg';
import chartScatterPlotIcon from '@disy/cadenza-icons/chart-scatter.svg';
import chartStackedAreasIconLg from '@disy/cadenza-icons/chart-stacked-area-lg.svg';
import chartStackedAreasIcon from '@disy/cadenza-icons/chart-stacked-area.svg';
import chartStackedBar100IconLg from '@disy/cadenza-icons/chart-stacked-bar-100-lg.svg';
import chartStackedBar100Icon from '@disy/cadenza-icons/chart-stacked-bar-100.svg';
import chartStackedBarIconLg from '@disy/cadenza-icons/chart-stacked-bar-lg.svg';
import chartStackedBarIcon from '@disy/cadenza-icons/chart-stacked-bar.svg';
import chartStackedColumn100IconLg from '@disy/cadenza-icons/chart-stacked-column-100-lg.svg';
import chartStackedColumn100Icon from '@disy/cadenza-icons/chart-stacked-column-100.svg';
import chartStackedColumnIconLg from '@disy/cadenza-icons/chart-stacked-column-lg.svg';
import chartStackedColumnIcon from '@disy/cadenza-icons/chart-stacked-column.svg';
import circeSectorsIconLg from '@disy/cadenza-icons/circle-sector-lg.svg';
import circeSectorsIcon from '@disy/cadenza-icons/circle-sector.svg';
import clusterIconLg from '@disy/cadenza-icons/cluster-lg.svg';
import clusterIcon from '@disy/cadenza-icons/cluster.svg';
import pointsIconLg from '@disy/cadenza-icons/dots-lg.svg';
import pointsIcon from '@disy/cadenza-icons/dots.svg';
import heatmapIconLg from '@disy/cadenza-icons/heatmap-lg.svg';
import heatmapIcon from '@disy/cadenza-icons/heatmap.svg';
import imageIconLg from '@disy/cadenza-icons/image-file-lg.svg';
import imageIcon from '@disy/cadenza-icons/image-file.svg';
import indicatorIconLg from '@disy/cadenza-icons/indicator-lg.svg';
import indicatorIcon from '@disy/cadenza-icons/indicator.svg';
import isochronesIconLg from '@disy/cadenza-icons/isochrones-lg.svg';
import isochronesIcon from '@disy/cadenza-icons/isochrones-theme.svg';
import reportIconLg from '@disy/cadenza-icons/jasper-report-lg.svg';
import reportIcon from '@disy/cadenza-icons/jasper-report.svg';
import linesIconLg from '@disy/cadenza-icons/lines-lg.svg';
import linesIcon from '@disy/cadenza-icons/lines.svg';
import pieIconLg from '@disy/cadenza-icons/pie-lg.svg';
import pieIcon from '@disy/cadenza-icons/pie.svg';
import rasterIconLg from '@disy/cadenza-icons/raster-lg.svg';
import rasterIcon from '@disy/cadenza-icons/raster.svg';
import referenceLineIcon from '@disy/cadenza-icons/reference-line.svg';
import routingIconLg from '@disy/cadenza-icons/routing-lg.svg';
import routingIcon from '@disy/cadenza-icons/routing-theme.svg';
import stepControlIconLg from '@disy/cadenza-icons/step-control-lg.svg';
import stepControlIcon from '@disy/cadenza-icons/step-control.svg';
import tableSimpleIconLg from '@disy/cadenza-icons/table-simple-lg.svg';
import tableSimpleIcon from '@disy/cadenza-icons/table-simple.svg';
import tableStructuredIconLg from '@disy/cadenza-icons/table-structured-lg.svg';
import tableStructuredIcon from '@disy/cadenza-icons/table-structured.svg';
import tableWritebackIconLg from '@disy/cadenza-icons/table-writeback-lg.svg';
import tableWritebackIcon from '@disy/cadenza-icons/table-writeback.svg';
import textWithDataIconLg from '@disy/cadenza-icons/text-lg.svg';
import textWithDataIcon from '@disy/cadenza-icons/text.svg';
import webpageIconLg from '@disy/cadenza-icons/visualization-type-webpage-view-lg.svg';
import webpageIcon from '@disy/cadenza-icons/visualization-type-webpage-view.svg';
import { assert, assertType } from '@disy/lib/custom-error';
import { type IconOptions } from '@disy/ui/icon';
import { icon } from '@disy/ui/icon';

import { ViewType, viewTypeIcon } from 'cadenza/workbook/api/view-type';

export const VISUALIZATIONS = [
  'TABLE.STRUCTURED',
  'TABLE.SIMPLE_AGGREGATED',
  'TABLE.INDIVIDUAL_VALUES',
  'TABLE.WRITEBACK',

  'MAP.ROUTES',
  'MAP.ISOCHRONES',
  'MAP.LINE',
  'MAP.POSTGIS_RASTER',
  'MAP.CIRCLE_SECTORS',
  'MAP.POINT',
  'MAP.POLYGON',
  'MAP.CLUSTERING_POINT',
  'MAP.HEATMAP',
  'MAP.MAP_PIE_CHART',

  'CHART.BULLET_BAR_CHART',
  'CHART.BULLET_COLUMN_CHART',
  'CHART.COLUMN_CHART',
  'CHART.GROUPED_COLUMN_CHART',
  'CHART.STACKED_COLUMN_CHART',
  'CHART.HUNDRED_PERCENT_COLUMN_CHART',
  'CHART.BAR_CHART',
  'CHART.GROUPED_BAR_CHART',
  'CHART.STACKED_BAR_CHART',
  'CHART.HUNDRED_PERCENT_BAR_CHART',
  'CHART.MIRROR_BAR_CHART',
  'CHART.PIE_CHART',
  'CHART.LINE_CHART',
  'CHART.MULTI_LINE_CHART',
  'CHART.SCATTER_PLOT_CHART',
  'CHART.REFERENCE_LINE_CHART',
  'CHART.STATIC_REFERENCE_LINE_CHART',
  'CHART.TREND_LINE_CHART',
  'CHART.STACKED_AREA_CHART',
  'CHART.MULTI_MEASURE_COLUMN_CHART',
  'CHART.MULTI_MEASURE_BAR_CHART',
  'CHART.MULTI_MEASURE_LINE_CHART',
  'CHART.MULTI_MEASURE_PIE_CHART',
  'CHART.MULTI_MEASURE_GROUPED_COLUMN_CHART',
  'CHART.MULTI_MEASURE_STACKED_COLUMN_CHART',
  'CHART.MULTI_MEASURE_HUNDRED_PERCENT_COLUMN_CHART',
  'CHART.MULTI_MEASURE_GROUPED_BAR_CHART',
  'CHART.MULTI_MEASURE_STACKED_BAR_CHART',
  'CHART.MULTI_MEASURE_HUNDRED_PERCENT_BAR_CHART',
  'CHART.MULTI_MEASURE_MIRROR_BAR_CHART',
  'CHART.MULTI_MEASURE_MULTI_LINE_CHART',
  'CHART.MULTI_MEASURE_STACKED_AREA_CHART',

  'OTHER.INDICATOR',
  'REPORT.JASPER_REPORT',
  'TEXT.WITH_DATA',
  'CONTROLLER.CONTROLLER',
  'WEBPAGE.WEBPAGE',
  'IMAGE.IMAGE',
] as const;

export function isDataViewVisualizationKey(key: string): key is DataViewVisualizationKey {
  return (
    VISUALIZATIONS.includes(key as DataViewVisualizationKey) || // This assertion is fine since it's only for the check
    key.startsWith('EXTENSION') // EXTENSION has UUID after the dot, so we only check for viewType
  );
}
/**
 * Type of the visualization denoted as concatenation of a {@see ViewType} and a
 * {@see VisualizationKey},e.g. 'CHART.COLUMN_CHART'.
 *
 * @see net/disy/cadenza/workbook/model/DataViewVisualizationKey.java
 */
export type DataViewVisualizationKey = (typeof VISUALIZATIONS)[number];

/** Not deprecated: the 2-level grouping is useful, e.g. get all the table visualization types */
export const DataViewVisualizationKey = VISUALIZATIONS.reduce(
  (result, key) => {
    const [viewType, viz] = key.split('.') as unknown as [ViewType, string];
    result[viewType] ??= {};
    result[viewType][viz] = key;
    return result;
  },
  {} as Record<ViewType, Record<string, DataViewVisualizationKey>>,
);

export type ChartDataViewVisualizationKey = Extract<DataViewVisualizationKey, `CHART.${string}`>;
export function isChartDataViewVisualizationKey(
  dataViewVisualizationKey: DataViewVisualizationKey | undefined,
): dataViewVisualizationKey is ChartDataViewVisualizationKey {
  return !!dataViewVisualizationKey && Object.values(DataViewVisualizationKey.CHART).includes(dataViewVisualizationKey);
}
export function asChartDataViewVisualizationKey(dataViewVisualizationKey: DataViewVisualizationKey) {
  assertType<ChartDataViewVisualizationKey>(
    dataViewVisualizationKey,
    isChartDataViewVisualizationKey(dataViewVisualizationKey),
  );
  return dataViewVisualizationKey;
}

export type TableDataViewVisualizationKey = Extract<DataViewVisualizationKey, `TABLE.${string}`>;

const STYLE_CLASS_POLYGON = 'visualization-icon--polygon';
const STYLE_CLASS_POINT = 'visualization-icon--point';
const STYLE_CLASS_DIMENSION_CLASSIFICATION = 'visualization-icon--dimension-classification';
const STYLE_CLASS_CLASSIFICATION = 'visualization-icon--classification';

interface IconInfo {
  smallIcon: string;
  largeIcon: string;
  styleClass?: string;
}

function createIcons(smallIcon: string, largeIcon: string): IconInfo {
  return {
    smallIcon,
    largeIcon,
  };
}

function createClassifiedIcons(smallIcon: string, largeIcon: string): IconInfo {
  return {
    smallIcon,
    largeIcon,
    styleClass: STYLE_CLASS_CLASSIFICATION,
  };
}

function createDimensionClassifiedIcons(smallIcon: string, largeIcon: string): IconInfo {
  return {
    smallIcon,
    largeIcon,
    styleClass: STYLE_CLASS_DIMENSION_CLASSIFICATION,
  };
}

function createPointIcons(smallIcon: string, largeIcon: string): IconInfo {
  return {
    smallIcon,
    largeIcon,
    styleClass: STYLE_CLASS_POINT,
  };
}

function createPolygonIcons(smallIcon: string, largeIcon: string): IconInfo {
  return {
    smallIcon,
    largeIcon,
    styleClass: STYLE_CLASS_POLYGON,
  };
}

const VISUALIZATION_ICONS: Record<DataViewVisualizationKey, IconInfo> = {
  'TABLE.STRUCTURED': createIcons(tableStructuredIcon, tableStructuredIconLg),
  'TABLE.SIMPLE_AGGREGATED': createIcons(tableSimpleIcon, tableSimpleIconLg),
  'TABLE.INDIVIDUAL_VALUES': createIcons(tableSimpleIcon, tableSimpleIconLg),
  'TABLE.WRITEBACK': createIcons(tableWritebackIcon, tableWritebackIconLg),

  'OTHER.INDICATOR': createIcons(indicatorIcon, indicatorIconLg),
  'TEXT.WITH_DATA': createIcons(textWithDataIcon, textWithDataIconLg),
  'REPORT.JASPER_REPORT': createIcons(reportIcon, reportIconLg),
  'CONTROLLER.CONTROLLER': createIcons(stepControlIcon, stepControlIconLg),
  'WEBPAGE.WEBPAGE': createIcons(webpageIcon, webpageIconLg),
  'IMAGE.IMAGE': createIcons(imageIcon, imageIconLg),

  'MAP.ROUTES': createIcons(routingIcon, routingIconLg),
  'MAP.ISOCHRONES': createIcons(isochronesIcon, isochronesIconLg),
  'MAP.LINE': createIcons(linesIcon, linesIconLg),
  'MAP.POSTGIS_RASTER': createIcons(rasterIcon, rasterIconLg),
  'MAP.CIRCLE_SECTORS': createIcons(circeSectorsIcon, circeSectorsIconLg),
  'MAP.POINT': createPointIcons(pointsIcon, pointsIconLg),
  'MAP.POLYGON': createPolygonIcons(polygonsIcon, polygonsIconLg),
  'MAP.CLUSTERING_POINT': createClassifiedIcons(clusterIcon, clusterIconLg),
  'MAP.HEATMAP': createIcons(heatmapIcon, heatmapIconLg),
  'MAP.MAP_PIE_CHART': createDimensionClassifiedIcons(pieIcon, pieIconLg),

  'CHART.BULLET_BAR_CHART': createIcons(chartBarBulletIcon, chartBarBulletIconLg),
  'CHART.BULLET_COLUMN_CHART': createIcons(chartColumnBulletIcon, chartColumnBulletIconLg),
  'CHART.COLUMN_CHART': createIcons(chartColumnIcon, chartColumnIconLg),
  'CHART.GROUPED_COLUMN_CHART': createIcons(chartGroupedColumnIcon, chartGroupedColumnIconLg),
  'CHART.STACKED_COLUMN_CHART': createIcons(chartStackedColumnIcon, chartStackedColumnIconLg),
  'CHART.HUNDRED_PERCENT_COLUMN_CHART': createIcons(chartStackedColumn100Icon, chartStackedColumn100IconLg),
  'CHART.BAR_CHART': createIcons(chartBarIcon, chartBarIconLg),
  'CHART.GROUPED_BAR_CHART': createIcons(chartGroupedBarIcon, chartGroupedBarIconLg),
  'CHART.STACKED_BAR_CHART': createIcons(chartStackedBarIcon, chartStackedBarIconLg),
  'CHART.HUNDRED_PERCENT_BAR_CHART': createIcons(chartStackedBar100Icon, chartStackedBar100IconLg),
  'CHART.MIRROR_BAR_CHART': createIcons(chartMirrorBarIcon, chartMirrorBarIconLg),
  'CHART.PIE_CHART': createDimensionClassifiedIcons(chartPieIcon, chartPieIconLg),
  'CHART.LINE_CHART': createIcons(chartLineIcon, chartLineIconLg),
  'CHART.MULTI_LINE_CHART': createIcons(chartMultiLineIcon, chartMultiLineIconLg),
  'CHART.STACKED_AREA_CHART': createIcons(chartStackedAreasIcon, chartStackedAreasIconLg),
  'CHART.SCATTER_PLOT_CHART': createIcons(chartScatterPlotIcon, chartScatterPlotIconLg),
  'CHART.REFERENCE_LINE_CHART': createIcons(referenceLineIcon, referenceLineIcon),
  'CHART.STATIC_REFERENCE_LINE_CHART': createIcons(referenceLineIcon, referenceLineIcon),
  'CHART.TREND_LINE_CHART': createIcons(chartLineIcon, chartLineIconLg),

  'CHART.MULTI_MEASURE_COLUMN_CHART': createIcons(chartColumnIcon, chartColumnIconLg),
  'CHART.MULTI_MEASURE_BAR_CHART': createIcons(chartBarIcon, chartBarIconLg),
  'CHART.MULTI_MEASURE_LINE_CHART': createIcons(chartLineIcon, chartLineIconLg),
  'CHART.MULTI_MEASURE_PIE_CHART': createIcons(chartPieIcon, chartPieIconLg),

  'CHART.MULTI_MEASURE_GROUPED_COLUMN_CHART': createIcons(chartColumnIcon, chartColumnIconLg),
  'CHART.MULTI_MEASURE_STACKED_COLUMN_CHART': createIcons(chartStackedColumnIcon, chartStackedColumnIconLg),
  'CHART.MULTI_MEASURE_HUNDRED_PERCENT_COLUMN_CHART': createIcons(
    chartStackedColumn100Icon,
    chartStackedColumn100IconLg,
  ),
  'CHART.MULTI_MEASURE_GROUPED_BAR_CHART': createIcons(chartGroupedBarIcon, chartGroupedBarIconLg),
  'CHART.MULTI_MEASURE_STACKED_BAR_CHART': createIcons(chartStackedBarIcon, chartStackedBarIconLg),
  'CHART.MULTI_MEASURE_HUNDRED_PERCENT_BAR_CHART': createIcons(chartStackedBar100Icon, chartStackedBar100IconLg),
  'CHART.MULTI_MEASURE_MIRROR_BAR_CHART': createIcons(chartMirrorBarIcon, chartMirrorBarIconLg),
  'CHART.MULTI_MEASURE_MULTI_LINE_CHART': createIcons(chartMultiLineIcon, chartMultiLineIconLg),
  'CHART.MULTI_MEASURE_STACKED_AREA_CHART': createIcons(chartStackedAreasIcon, chartStackedAreasIconLg),
};

const STYLE_CLASS = 'visualization-icon';

interface VisualizationIconOptions extends IconOptions {
  svgSize?: 'sm' | 'lg';
}

export function visualizationIcon(key: DataViewVisualizationKey, options: VisualizationIconOptions = {}) {
  let iconElement;
  if (key in VISUALIZATION_ICONS) {
    const iconInfo = VISUALIZATION_ICONS[key]!; // checked above
    let style = STYLE_CLASS;
    if (iconInfo.styleClass) {
      style = style + ' ' + iconInfo.styleClass;
    }
    const iconSvg = options.svgSize === 'lg' ? iconInfo.largeIcon : iconInfo.smallIcon;
    iconElement = icon(iconSvg, { styleClass: style, ...options });
  } else {
    // fallback
    // This fallback is also used by EXTENSION visualization keys where all visualizations use the icon of EXTENSION view.
    iconElement = viewTypeIcon(key.split('.')[0] as ViewType);
    iconElement.classList.add(STYLE_CLASS);
  }
  if (options.svgSize === 'lg') {
    iconElement.classList.add(STYLE_CLASS + '-lg');
  }
  return iconElement;
}

/**
 * Gets the view type of a visualization key
 *
 * @param key - A visualization key
 * @return The view type of the visualization key
 */
export function getViewType(key: DataViewVisualizationKey) {
  return Object.values(ViewType).find((type) => isViewType(key, type));
}

/**
 * Tests whether the visualization key is of the given view type.
 *
 * @param key - The visualization key to test
 * @param viewType - The view type to test against
 * @return `true` if the visualization key is of the given view type
 */
export function isViewType(key: DataViewVisualizationKey, viewType: ViewType) {
  return viewType in DataViewVisualizationKey && Object.values(DataViewVisualizationKey[viewType]).includes(key);
}

export type MapVisualizationKey = DataViewVisualizationKey & `MAP.${string}`;

/*
 * Exporting this as a separate util,
 * because maps are always special ...
 */
export function isMap(value: string): value is MapVisualizationKey {
  return isViewType(value as DataViewVisualizationKey, ViewType.MAP);
}

export function isPieChart(visualizationKey: DataViewVisualizationKey) {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.PIE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_PIE_CHART
  );
}

export function isBulletChart(visualizationKey: DataViewVisualizationKey) {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.BULLET_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.BULLET_COLUMN_CHART
  );
}

export function isBarChart(visualizationKey: DataViewVisualizationKey) {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.GROUPED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.HUNDRED_PERCENT_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MIRROR_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_MIRROR_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.BULLET_BAR_CHART
  );
}

export function isMultiMeasureChart(visualizationKey: DataViewVisualizationKey) {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_LINE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_PIE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_MULTI_LINE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_AREA_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_MEASURE_MIRROR_BAR_CHART
  );
}

export function isMultiMeasureChartAvailable(visualizationKey: DataViewVisualizationKey) {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.LINE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.PIE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.GROUPED_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.HUNDRED_PERCENT_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.GROUPED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.HUNDRED_PERCENT_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_LINE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_AREA_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MIRROR_BAR_CHART
  );
}

export function isSubCategoryChart(visualizationKey: DataViewVisualizationKey) {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.GROUPED_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.HUNDRED_PERCENT_COLUMN_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.GROUPED_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.HUNDRED_PERCENT_BAR_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MULTI_LINE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STACKED_AREA_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.MIRROR_BAR_CHART
  );
}

export function getMultiMeasureFromSimpleChart(visualizationKey: DataViewVisualizationKey) {
  assert(
    isMultiMeasureChartAvailable(visualizationKey),
    `Measures only chart is not available for ${visualizationKey}`,
  );
  switch (visualizationKey) {
    case DataViewVisualizationKey.CHART.COLUMN_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.BAR_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_BAR_CHART;
    case DataViewVisualizationKey.CHART.LINE_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_LINE_CHART;
    case DataViewVisualizationKey.CHART.PIE_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_PIE_CHART;
    case DataViewVisualizationKey.CHART.GROUPED_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.STACKED_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.HUNDRED_PERCENT_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.GROUPED_BAR_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_BAR_CHART;
    case DataViewVisualizationKey.CHART.STACKED_BAR_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_BAR_CHART;
    case DataViewVisualizationKey.CHART.HUNDRED_PERCENT_BAR_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_BAR_CHART;
    case DataViewVisualizationKey.CHART.MIRROR_BAR_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_MIRROR_BAR_CHART;
    case DataViewVisualizationKey.CHART.MULTI_LINE_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_MULTI_LINE_CHART;
    case DataViewVisualizationKey.CHART.STACKED_AREA_CHART:
      return DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_AREA_CHART;
  }
  return visualizationKey;
}

export function getSimpleChartFromMultiMeasureChart(visualizationKey: DataViewVisualizationKey) {
  assert(isMultiMeasureChart(visualizationKey), `${visualizationKey} is not measures only chart`);
  switch (visualizationKey) {
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.COLUMN_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_BAR_CHART:
      return DataViewVisualizationKey.CHART.BAR_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_LINE_CHART:
      return DataViewVisualizationKey.CHART.LINE_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_PIE_CHART:
      return DataViewVisualizationKey.CHART.PIE_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.GROUPED_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.STACKED_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_COLUMN_CHART:
      return DataViewVisualizationKey.CHART.HUNDRED_PERCENT_COLUMN_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_GROUPED_BAR_CHART:
      return DataViewVisualizationKey.CHART.GROUPED_BAR_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_BAR_CHART:
      return DataViewVisualizationKey.CHART.STACKED_BAR_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_HUNDRED_PERCENT_BAR_CHART:
      return DataViewVisualizationKey.CHART.HUNDRED_PERCENT_BAR_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_MIRROR_BAR_CHART:
      return DataViewVisualizationKey.CHART.MIRROR_BAR_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_MULTI_LINE_CHART:
      return DataViewVisualizationKey.CHART.MULTI_LINE_CHART;
    case DataViewVisualizationKey.CHART.MULTI_MEASURE_STACKED_AREA_CHART:
      return DataViewVisualizationKey.CHART.STACKED_AREA_CHART;
  }
  return visualizationKey;
}

export function isScatterPlotChart(visualizationKey: DataViewVisualizationKey) {
  return visualizationKey === DataViewVisualizationKey.CHART.SCATTER_PLOT_CHART;
}

const ANALYTIC_LINE_VISUALIZATION_KEYS = [
  'CHART.TREND_LINE_CHART',
  'CHART.REFERENCE_LINE_CHART',
  'CHART.STATIC_REFERENCE_LINE_CHART',
] as const satisfies ChartDataViewVisualizationKey[];

export type AnalyticLineVisualizationKey = (typeof ANALYTIC_LINE_VISUALIZATION_KEYS)[number];

const EMPTY_BUNDLE_ANALYTIC_LINE_VISUALIZATION_KEYS = [
  'CHART.TREND_LINE_CHART',
  'CHART.STATIC_REFERENCE_LINE_CHART',
] as const satisfies ChartDataViewVisualizationKey[];

export type EmptyBundleAnalyticLineVisualizationKey = (typeof EMPTY_BUNDLE_ANALYTIC_LINE_VISUALIZATION_KEYS)[number];

export function isTrendLine(visualizationKey: DataViewVisualizationKey) {
  return visualizationKey === DataViewVisualizationKey.CHART.TREND_LINE_CHART;
}

export function isReferenceLine(
  visualizationKey: DataViewVisualizationKey,
): visualizationKey is 'CHART.REFERENCE_LINE_CHART' | 'CHART.STATIC_REFERENCE_LINE_CHART' {
  return (
    visualizationKey === DataViewVisualizationKey.CHART.REFERENCE_LINE_CHART ||
    visualizationKey === DataViewVisualizationKey.CHART.STATIC_REFERENCE_LINE_CHART
  );
}

export function isAnalyticLine(
  visualizationKey: DataViewVisualizationKey,
): visualizationKey is AnalyticLineVisualizationKey {
  return ANALYTIC_LINE_VISUALIZATION_KEYS.includes(visualizationKey as AnalyticLineVisualizationKey);
}

export function isEmptyBundleAnalyticLine(
  visualizationKey: DataViewVisualizationKey,
): visualizationKey is EmptyBundleAnalyticLineVisualizationKey {
  return EMPTY_BUNDLE_ANALYTIC_LINE_VISUALIZATION_KEYS.includes(
    visualizationKey as EmptyBundleAnalyticLineVisualizationKey,
  );
}

export function asAnalyticLineVisualizationKey(dataViewVisualizationKey: DataViewVisualizationKey) {
  assertType<AnalyticLineVisualizationKey>(dataViewVisualizationKey, isAnalyticLine(dataViewVisualizationKey));
  return dataViewVisualizationKey;
}
